<template>
  <v-container>
    <v-snackbar v-model="ok_snackbar" :timeout="3000" color="green darken-3 white--text" :top="true">
      {{ ok_text }}
      <v-btn color="white" flat @click="ok_snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-snackbar v-model="error_snackbar" :timeout="3000" color="red darken-3 white--text" :top="true">
      {{ error_text }}
      <v-btn color="white" flat @click="error_snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-dialog
      v-model="dialogUhrada"
      persistent
      max-width="1200px"
      transition="dialog-transition"
      v-if="dialogUhrada"
    >
      <v-card class="no__padding">
        <v-card-title class="pl-0">
          <h2>Úhrada z peněženky</h2>
        </v-card-title>
        <v-card color="white lighten-4" class="pa-0 elevation-0">
          <v-card-text>
            <Loader v-if="searchingPair" skin="light" class="pt-5 pb-5"></Loader>
            <v-layout row wrap v-else>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs12>
                    <p class="mb-2"><strong>Výše platby:</strong></p>
                    <v-form v-model="uhrada_valid" lazy-validation ref="dialogUhradaForm">
                      <v-layout row wrap>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="Částka"
                            type="number"
                            :rules="rules"
                            suffix="Kč"
                            v-model="castka"
                            class="mr-3 mt-0"
                            @input="(e) => { novy_zustatek = aktualni_zustatek - (castka != null && !isNaN(castka) ? parseInt(castka) : 0) }"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-form>
                    <v-layout row wrap>
                      <v-flex class="caption">
                        Aktuální zůstatek {{ aktualni_zustatek | formatMoney }} Kč. <span v-if="!isNaN(castka) && parseInt(castka) >= 0">Nový zůstatek po úhradě {{ novy_zustatek | formatMoney }} Kč.</span>
                      </v-flex>
                    </v-layout>
                    <p class="mt-3"><strong>Návrhy pro platbu:</strong></p>
                    <div class="mt-3 mr-3 mb-3">
                      <v-data-table
                        :headers="pairHeadersSporeni"
                        :items="navrhy_sporeni"
                        :pagination.sync="pagination"
                        :total-items="pagination.totalItems"
                        :rows-per-page-items="[25, 50, 100, 200]"
                        class="elevation-0 mt-0 mb-2"
                        item-key="id"
                        color="grey"
                        v-if="navrhy_sporeni.length>0"
                      >
                        <template slot="items" slot-scope="props">
                          <td><span>{{ props.item.nazev_sporeni }}</span></td>
                          <td><span>{{ props.item.variabilni_symbol }}</span></td>
                          <td>
                            <span v-if="props.item.stav_sporeni=='probiha'">Probíhá</span>
                          </td>
                          <td><span>{{ props.item.mena.nazev }}</span></td>
                          <td class="text-xs-right">
                            <v-btn color="orange" dark class="elevation-0 ma-0 bold" depressed small @click="uhradit('sporeni', props.item.id)">Uhradit postupný nákup</v-btn>
                          </td>
                        </template>
                      </v-data-table>
                      <v-data-table
                        :headers="pairHeadersObjednavky"
                        :items="navrh_objednavky"
                        :pagination.sync="pagination"
                        :total-items="pagination.totalItems"
                        :rows-per-page-items="[25, 50, 100, 200]"
                        class="elevation-0 mb-2"
                        item-key="id"
                        color="grey"
                        v-if="navrh_objednavky.length>0"
                      >
                        <template slot="items" slot-scope="props">
                          <td><span>{{ props.item.cislo_objednavky }}</span></td>
                          <td><span>{{ props.item.variabilni_symbol }}</span></td>
                          <td><span>{{ props.item.castka_celkem | formatMoney }} {{ props.item.mena.zkratka }}</span></td>
                          <!-- <td><strong>{{ props.item.stav_objednavky }}</strong></td> -->
                          <td class="text-xs-right">
                            <v-btn color="orange" dark class="elevation-0 ma-0 bold" depressed small @click="uhradit('jednorazovy_nakup', props.item.id)">Uhradit jednorázový nákup</v-btn>
                          </td>
                        </template>
                      </v-data-table>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card-actions class="mt-3 pr-0">
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-3 elevation-0" @click="dialogUhrada=false">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <v-flex xs12>
        <h1 class="h2 mt-2 mb-30">Elektronická peněženka</h1>
      </v-flex>
      <v-layout row wrap class="shop-layout">
        <v-flex xs12 sm4 class="px-3 pointer" v-for="p in penezenky" :key="'penezenka-'+p.id.toString()" @click="mena=p.mena">
          <div class="wallet-state wallet-dashboard" :class="{'credit-state__active': mena.id == p.mena.id}">
            <h3 class="h1" :class="{'text-white': mena.id == p.mena.id, 'black-white': mena.id != p.mena.id}">{{p.aktualni_zustatek | formatMoney}} {{p.mena.zkratka}}</h3>
          </div>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-btn color="orange" dark class="elevation-0 ma-0 bold" @click="uhraditClick">Provést úhradu nákupu z peněženky</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="mt-4" v-if="pohledavky != null && pohledavky.length > 0">
      <v-flex xs12>
        <h3>Nedoplatky jednorázových nákupů</h3>
        <v-data-table
          :headers="pohledavkyHeaders"
          :items="pohledavky"
          class="elevation-0 mt-2"
          hide-actions
        >
          <template v-slot:items="props">
            <td>{{ props.item.variabilni_symbol }}</td>
            <td class="text-xs-right">
              {{ props.item.castka_celkem | formatMoney }} Kč
            </td>
            <td class="text-xs-right">
              {{ props.item.castka_celkem_fixace | formatMoney }} Kč
            </td>
            <td class="text-xs-right">
              {{ props.item.nedoplatek | formatMoney }} Kč
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="mt-4">
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-0"
          :pagination.sync="pagination"
          :total-items="pagination.totalItems"
          :rows-per-page-items="[25, 50, 100, 200]"
          :loading="loadingTable"
          hide-actions
        >
          <template v-slot:items="props">
            <td>{{ props.item.datum | formatSimpleDate }}</td>
            <td>
              <span v-if="props.item.castka > 0" class="state-ok"></span>
              <span v-else class="state-nok"></span>
              {{ props.item.castka | formatMoney }} {{mena.zkratka}}
            </td>
            <td>{{ props.item.variabilni_symbol }}</td>
            <td>{{ props.item.popis }}</td>
            <td>
              <span v-if="props.item.stav == 'sparovano'">Spárováno</span>
              <span v-else>{{ props.item.stav }}</span>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Base from '../../Base'
  export default {
    extends: Base,
    data () {
      return {
        loading: true,
        loadingTable: true,
        penezenky: [],
        pohledavkyHeaders: [
          { text: 'Číslo objednávky', value: 'variabilni_symbol', sortable: false },
          { text: 'Částka objednávky', value: 'castka_celkem', sortable: false, align: 'right' },
          { text: 'Částka fixace', value: 'castka_celkem_fixace', sortable: false, align: 'right' },
          { text: 'Nedoplatek', value: 'nedoplatek', sortable: false, align: 'right' }
        ],
        headers: [
          { text: 'Datum', value: 'datum', sortable: false },
          { text: 'Částka', value: 'castka', sortable: false },
          { text: 'Variabilní symbol', value: 'variabilni_symbol', sortable: false },
          { text: 'Popis transakce', value: 'popis_transakce', sortable: false },
          { text: 'Stav', value: 'stav', sortable: false }
        ],
        items: [],
        mena: null,
        timeout: null,
        counter: 0,
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 25,
          sortBy: "datum",
          totalItems: 0,
          pages: 0
        },
        ok_snackbar: false,
        ok_text: null,
        error_snackbar: false,
        error_text: null,
        dialogUhrada: false,
        searchingPair: false,
        pairHeadersSporeni: [
          { text: 'Název spoření', value: 'nazev_sporeni', sortable: false },
          { text: 'Variabilní symbol', value: 'variabilni_symbol', sortable: false },
          { text: 'Stav spoření', value: 'stav_sporeni', sortable: false },
          { text: 'Měna', value: 'mena', sortable: false },
          { text: '', value: 'id', sortable: false }
        ],
        pairHeadersObjednavky: [
          { text: 'Číslo nákupu', value: 'cislo_nakupu', sortable: false },
          { text: 'Variabilní symbol', value: 'variabilni_symbol', sortable: false },
          { text: 'Částka celkem', value: 'castka_celkem', sortable: false },
          { text: '', value: 'id', sortable: false }
        ],
        rules: [
          (v) => (!!v && !isNaN(v)) || "Částka musí být zadána"
        ],
        rulesRequired: [
          (v) => !!v || "Pole je vyžadováno"
        ],
        castka: null,
        navrhy_sporeni: [],
        navrh_objednavky: [],
        aktualni_zustatek: 0,
        novy_zustatek: 0,
        uhrada_valid: true,
        pohledavky: []
      }
    },
    props: {
      klient: String
    },
    watch: {
      mena () {
        this.loadTable();
      },
      pagination: {
    		handler: function(newValue) {
          if (!this.loadingTable)
    			   this.loadTable();
    		},
    		deep: true
    	},
    },
    mounted () {
      this.load();
    },
    methods: {
      load (fn) {
        this.loading = true;
        window.API.get("klient/penezenka/"+this.klient).then(function(body) {
          this.penezenky.replace(body);
          this.loading = false;
          if (this.penezenky.length > 0)
            this.mena = this.penezenky[0].mena;
          if (typeof fn == "function")
            fn();
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      loadTable: function(fn) {
        this.counter++;
        this.loadingTable = true;
        this.items = [];
        window.API.post("klient/penezenka/"+this.klient+"/"+this.mena.identifikator+"/platby/search", {
          pagination: this.pagination,
          s: this.search,
          echo: this.counter
        }).then(function(body) {
          if (typeof fn == "function")
            fn();
          if (this.counter != body.echo)
            return;
          this.pohledavky = body.pohledavky;
          this.items = body.data;
          this.pagination.sortBy = body.sort.sortBy;
          this.kategorie_items = [ { id: null, nazev: "Vše" } ].concat(body.kategorie);
          this.pagination.descending = body.sort.descending;
          this.pagination.page = body.sort.page;
          this.pagination.rowsPerPage = body.sort.rowsPerPage;
          this.pagination.totalItems = body.sort.totalItems;
          this.pagination.pages = body.sort.pages;
          this.loading = false;
          this.loadingTable = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      uhraditClick () {
        this.dialogUhrada = true;
        this.searchingPair = true;
        window.API.get("klient/nakupy/"+this.klient+"/uhrada-navrhy").then(function(body) {
          this.navrhy_sporeni = body.sporeni;
          this.navrh_objednavky = body.objednavky;
          this.castka = body.penezenka.aktualni_zustatek;
          this.aktualni_zustatek = body.penezenka.aktualni_zustatek;
          this.novy_zustatek = body.penezenka.aktualni_zustatek - this.castka;
          this.searchingPair = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.searchingPair = false;
        }.bind(this));
      },
      uhradit (typ, id) {
        if (this.$refs.dialogUhradaForm.validate()) {
          var castka = this.castka != null && !isNaN(this.castka) ? parseFloat(this.castka) : 0;
          if (castka > 0 && castka <= this.aktualni_zustatek) {
            this.searchingPair = true;
            window.API.post("klient/nakupy/"+this.klient+"/uhrada", {
              typ: typ,
              id: id,
              castka: this.castka
            }).then(function(body) {
              if (body.created) {
                this.load(() => {
                  this.loadTable(() => {
                    this.dialogUhrada = false;
                    this.searchingPair = false;
                    this.ok_snackbar = true;
                    this.ok_text = "Úhradu byla provedena.";
                  });
                });
              }
              else {
                this.searchingPair = false;
                this.error_snackbar = true;
                this.error_text = "Úhradu nebylo možné provést.";
              }
            }.bind(this)).catch(function(err) {
              console.log(err);
              this.searchingPair = false;
            }.bind(this));
          }
          else if (castka <= 0) {
            this.error_snackbar = true;
            this.error_text = "Částka musí být větší než 0.";
          }
          else if (castka > this.aktualni_zustatek) {
            this.error_snackbar = true;
            this.error_text = "Částka je vyšší než zůstatek.";
          }
        }
      }
    }
  }
</script>
